// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609062355/js/" + chunkId + "." + {"44":"4f015176","225":"ed11e34d","481":"69b388a5","486":"49cefd44","770":"dd2c7ede"}[chunkId] + ".0.09661381013905201.chunk.js";
};